var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layer',{ref:"layer"},_vm._l((_vm.lines),function(conf,i){return _c('v-line',{key:i,attrs:{"config":conf}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }